
import Vue from 'vue'
import Vuex from 'vuex'
import cookies from '../utils/cookie'
import axiosApi from '../utils/api'
import pubg from '../assets/picture/PUBG MOBILE.png'
import goddess from '../assets/picture/Goddess of Victory Nikke.png'
import freeFire from '../assets/picture/Free Fire.png'
import roblox from '../assets/picture/Roblox.png'
import arena from '../assets/picture/Arena Breakout.png'
import honor from '../assets/picture/Honor of Kings.png'
import alchemy from '../assets/picture/Alchemy Stars.png'
import metal from '../assets/picture/Metal Slug Awakening.png'
import tft from '../assets/picture/TFT Teamfight Tactics.png'
import dungeon from '../assets/picture/Dungeon & Fighter Mobile.png'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
      dialogFlg:false,
      dialogContent:{},
      token:cookies.getToken(),
      langOptions:[],
      currencyOptions:[],
      currency:'',
      lang:'',
      defaultList:[
        {categoryId:'3140433533497385',categoryId_act:'2837902080954465',categoryName_CH:'PUBG绝地求生',categoryName:'PUBG MOBILE',src:pubg,},
        {categoryId:'62509959123648635',categoryId_act:'67326264711684131',categoryName_CH:'胜利女神',categoryName:'Goddess of Victory: Nikke',src:goddess,},
        {categoryId:'326082764176007246',categoryId_act:'18331920017379355',categoryName_CH:'我要活下去',categoryName:'Free Fire',src:freeFire,}, 
        {categoryId:'17965713565143082',categoryId_act:'',categoryName_CH:'罗布乐思',categoryName:'Roblox',src:roblox,},
        {categoryId:'147464881456955402',categoryId_act:'',categoryName_CH:'暗影突围',categoryName:'Arena Breakout',src:arena,},
        {categoryId:'246370387618328699',categoryId_act:'',categoryName_CH:'王者荣耀',categoryName:'Honor of Kings',src:honor,},
        {categoryId:'21319528855531577',categoryId_act:'',categoryName_CH:'白夜极光',categoryName:'Alchemy Stars',src:alchemy,},
        {categoryId:'212251611968204837',categoryId_act:'',categoryName_CH:'合金彈頭',categoryName:'Metal Slug Awakening',src:metal,},
        {categoryId:'18571288315330580',categoryId_act:'',categoryName_CH:'云顶之弈',categoryName:'TFT Teamfight Tactics',src:tft,},
        {categoryId:'18927037910843479',categoryId_act:'',categoryName_CH:'DNF地下城与勇士',categoryName:'Dungeon & Fighter Mobile',src:dungeon,},
      ]
    },
  
    mutations: {
      setDialogFlg(state,value){
        state.dialogFlg = value
      },
      setDialogContent(state,value){
        state.dialogContent = value
      },
      setLangOptions(state,value){
        state.langOptions = value
      },
      setCurrencyOptions(state,value){
        state.currencyOptions = value
      },
      setCurrency(state,value){
        state.currency = value
      },
      setLang(state,value){
        state.lang = value
      }
    },
    actions:{
      getLanguage({commit},{dictType}){
        axiosApi.getDictType({dictType}).then(res=>{
          commit('setLangOptions',res.data)
          res.data.map(v=>{
            if(v.dictSort==1){
              commit('setLang',v)
            }
          })
        })
      },
      getCurrency({commit},{dictType}){
        axiosApi.getDictType({dictType}).then(res=>{
          commit('setCurrencyOptions',res.data)
          res.data.map(v=>{
            if(v.dictSort == 1){
              commit('setCurrency',v)
            }
          })
         
        })
      },
    }
  })
